import { CellProps } from './CellProps'
import { HeaderCellDefn } from './HeaderColDef'

interface NodeDef {
  key: string
  /**
   * Flag for disabling cell
   */
  labelKey?: string
  disableKey?: string
  path?: string
  component: Function
}

/**
 * Column definition mapping props
 */
interface TableViewColumnDefinitionProps {
  id: string
  width?: number
  isVisible?: boolean
  isFixed?: boolean
  isRootColumn?: boolean
  props?: CellProps
  header: HeaderCellDefn
  node: NodeDef
  showColumnFilter?: boolean
  isBoolean?: boolean
}

export class TableViewColumnDefinition {
  /**
   * Unique identifier for column, will be required for updating defn on user action
   * (e.g. toggle isVisible flag)
   */
  id: string

  /**
   * Width of column in pixels
   */
  width: number

  /**
   * Flag specifying if column should be rendered.
   * Defaults to true
   */
  isVisible: boolean = true

  /**
   * Flag specifying id column should be fixed
   * Defaults to false
   */
  isFixed: boolean = false

  /**
   * Flag specifying if column is root
   * Defaults to false
   */
  isRootColumn: boolean = false

  /**
   * Props to be passed to components rendered in rows
   */
  props?: CellProps

  header: HeaderCellDefn

  /**
   * Function that returns react component to be rendered in row cell
   */
  node: NodeDef

  /**
   * Flag specifying if column filter should display
   * Defaults to false
   */
  showColumnFilter?: boolean = false

  /**
   * Flag specifying if column is of type boolean
   * Defaults to false
   */
  isBoolean?: boolean = false

  constructor(props: TableViewColumnDefinitionProps) {
    this.id = props.id
    this.width = props.width
    // props.isVisible || true -> will always default to true
    this.isVisible = 'isVisible' in props ? props.isVisible : true
    this.isFixed = props.isFixed || false
    this.isRootColumn = props.isRootColumn || false
    this.props = props.props
    this.header = {
      label: props.header.label,
      isDisabled: props.header ? props.header.isDisabled || false : false,
      action: props.header.action !== undefined ? props.header.action : null,
      className: props.header.className ?? null
    }
    this.node = {
      key: props.node.key,
      labelKey: props.node.labelKey,
      disableKey: props.node.disableKey || null,
      path: props.node.path || null,
      component: props.node.component
    }
    this.showColumnFilter = props.showColumnFilter
    this.isBoolean = props.isBoolean
  }
}
